export default __webpack_public_path__ + "static/media/banner185.2fac1ff3.png";